// breakwater-fe/src/reducers/agentEscalationReducer.js
import {
  LOAD_AGENT_ESCALATIONS, LOAD_AGENT_ESCALATIONS_SUCCESS, LOAD_AGENT_ESCALATIONS_FAIL,
  LOAD_AGENT_ESCALATION_SUCCESS,
  RESOLVE_AGENT_ESCALATION_SUCCESS, DISMISS_AGENT_ESCALATION_SUCCESS,
  SELECT_AGENT_ESCALATION,
} from '../actions/AgentEscalationActions';

const initial = {
  loading: false,
  error: null,
  escalations: [],
  counts: {},
  selected: null,
  filters: { status: 'open' },
};

export default function agentEscalationReducer(state = initial, action) {
  switch (action.type) {
    case LOAD_AGENT_ESCALATIONS:
      return { ...state, loading: true, error: null, filters: action.filters || state.filters };
    case LOAD_AGENT_ESCALATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        escalations: action.escalations,
        counts: action.counts,
        filters: action.filters || state.filters,
      };
    case LOAD_AGENT_ESCALATIONS_FAIL:
      return { ...state, loading: false, error: action.error };
    case SELECT_AGENT_ESCALATION:
      return { ...state, selected: action.escalation };
    case LOAD_AGENT_ESCALATION_SUCCESS:
      return {
        ...state,
        selected: action.escalation,
        escalations: state.escalations.map(e => e.id === action.escalation.id ? action.escalation : e),
      };
    case RESOLVE_AGENT_ESCALATION_SUCCESS:
    case DISMISS_AGENT_ESCALATION_SUCCESS: {
      const updated = action.escalation;
      const visible = state.filters.status === updated.status;
      return {
        ...state,
        selected: updated,
        escalations: visible
          ? state.escalations.map(e => e.id === updated.id ? updated : e)
          : state.escalations.filter(e => e.id !== updated.id),
      };
    }
    default:
      return state;
  }
}
